'use client';

import { useEffect, useMemo, useRef } from 'react';
import { usePathname } from 'i18n/routing';
import { useCookies } from 'next-client-cookies';
import { useSearchParams } from 'next/navigation';
import { useMessagePort } from 'providers/message-channel';

const PostMessageonUrlChange = () => {
  const cookies = useCookies();
  const locale = cookies.get('locale') as string;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const SENSITIVE_PARAMS = ['token'];

  const currentPath = useMemo(() => {
    const params = new URLSearchParams(searchParams.toString());

    SENSITIVE_PARAMS.forEach((param) => params.delete(param));

    const query = params.toString();

    return query ? `${pathname}?${query}` : pathname;
  }, [pathname, searchParams, locale]);

  const { sendToHost } = useMessagePort();
  const lastSentRef = useRef<string | null>(null);

  useEffect(() => {
    // Send the URL message + the PORT to the parent
    if (lastSentRef.current === currentPath) return;
    if (globalThis.window !== undefined) {
      sendToHost({ type: 'fujifilmNavigation', payload: { path: currentPath } });

      lastSentRef.current = currentPath;
    }
  }, [currentPath, locale]);

  return <></>;
};

export default PostMessageonUrlChange;
